export let help_tab = "$JLmCb";
export let help_Button = "Wqa6Yc";
export let support_Button = "Quk6ge";
export let feedbackOcv_Button = "aUsvve";
export let rolloutOverrides_Button = "bNDVLd";
export let diagnostics_Button = "B$EVb";
export let qrCode_Button = "dWnS9";
export let switchToClassicOutlook_Button = "Jwi$Nb";
export let helpButtonDesc = "SK0iJ";
export let contactSupportButtonDesc = "QSmgJc";
export let feedbackButtonDesc = "YrJtLb";
export let rolloutOverridesButtonDesc = "rStjr";
export let getDiagnosticsButtonDesc = "NBe5Ec";
export let qrCodeButtonDesc = "RzdJgb";
export let switchToClassicOutlookButtonDesc = "pn6W1d";
export let tipsButton = "EsUFPc";
export let tipsButtonDescription = "mjqUsd";
export default {help_tab,help_Button,support_Button,feedbackOcv_Button,rolloutOverrides_Button,diagnostics_Button,qrCode_Button,switchToClassicOutlook_Button,helpButtonDesc,contactSupportButtonDesc,feedbackButtonDesc,rolloutOverridesButtonDesc,getDiagnosticsButtonDesc,qrCodeButtonDesc,switchToClassicOutlookButtonDesc,tipsButton,tipsButtonDescription};